import { render } from "./TheTicket.vue?vue&type=template&id=f0cf0cba"
import script from "./TheTicket.vue?vue&type=script&lang=js"
export * from "./TheTicket.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "f0cf0cba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f0cf0cba', script)) {
    api.reload('f0cf0cba', script)
  }
  
  module.hot.accept("./TheTicket.vue?vue&type=template&id=f0cf0cba", () => {
    api.rerender('f0cf0cba', render)
  })

}

script.__file = "src/views/support/modules/tickets/TheTicket.vue"

export default script